import { TrashSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import { Input } from 'components/elements';
import { IconButton } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { HalfContainer } from 'components/styles';
import { SectionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import AirlineTable from './airline-table';
import { InputContainer, RightButtonContainer } from '../../style';

interface Props {
  parentIndex: number;
  onRemove: () => void;
  fieldLength?: number;
}

export default function FlightSection(props: Props) {
  const { t } = useTranslation();
  const { editable } = useFormState();
  return (
    <div>
      <SectionContainer>
        <HalfContainer>
          <InputContainer>
            <Input
              type="text"
              name={`tourFlights[${props.parentIndex}].name`}
              label={t('common:schedule_name')}
              placeholder={t('common:schedule_name')}
              required
              noMargin
            />
          </InputContainer>
        </HalfContainer>
        <HalfContainer>
          <InputContainer>
            <Input
              type="text"
              name={`tourFlights[${props.parentIndex}].note`}
              label={t('common:note')}
              placeholder={t('common:note')}
              noMargin
            />
          </InputContainer>
        </HalfContainer>
        <RightButtonContainer>
          {(props.fieldLength || 0) >= 0 && editable && (
            <IconButton
              buttonType="tertiary"
              overrides={{
                Root: {
                  style: {
                    height: '100%',
                    ':hover': {
                      backgroudnColor: stylesColors.redDefault,
                    },
                  },
                },
              }}
              onClick={props.onRemove}
            >
              <TrashSVG color={stylesColors.redDefault} />
            </IconButton>
          )}
        </RightButtonContainer>
      </SectionContainer>

      <AirlineTable parentIndex={props.parentIndex} />
    </div>
  );
}
